<template>
  <b-container class="the-detail">
    <b-form @submit.stop.prevent="create">
      <b-row>
        <h1 class="pageheading">{{ $t('certificationBody.titles.create') }}</h1>
      </b-row>
      <b-row class="the-detail__toolbar">
        <CRUDToolbar
          :hasBackButton="false"
          :clickFn="create">
        </CRUDToolbar>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('certificationBody.labelAsTitle.name') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              v-validate="{ required: true }"
              :class="{'validation--error': veeErrors.has('name') }"
              name="name"
              id="name"
              v-model="formInputs.name">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('certificationBody.labelAsTitle.registrationNumber') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              v-validate="{ required: true }"
              :class="{'validation--error': veeErrors.has('registrationNumber') }"
              name="registrationNumber"
              id="certificateNr"
              v-model="formInputs.registration_number">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.street') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              id="street"
              v-model="formInputs.street">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.zip') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              id="zip"
              v-model="formInputs.zip">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.location') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              id="location"
              v-model="formInputs.location">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('certificationBody.labelAsTitle.country') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <Countries
              v-on:country="setCountry"
              :showLabel="false">
            </Countries>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.phone') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              name="phone"
              id="phone"
              v-model="formInputs.phone">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.fax') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              id="fax"
              v-model="formInputs.fax">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.email') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              name="email"
              id="email"
              v-model="formInputs.email">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.website') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              id="website"
              v-model="formInputs.website">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('certificationBody.labelAsTitle.userEmail') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              v-validate="{ required: true }"
              :class="{'validation--error': veeErrors.has('userEmail') }"
              name="userEmail"
              type="email"
              id="userEmail"
              v-model="formInputs.userEmail">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.moreContacts') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              id="moreContacts"
              v-model="formInputs.moreContacts">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.intern_field') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-textarea
              id="internField"
              v-model="formInputs.intern_field">
            </b-form-textarea>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.logo') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <FileInput v-on:setFile="setFile" />
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">SCOPE OF EMPOWERMENT</h3>
        <Assignment
          :class="{ 'validation--error': !showAssignmentError }"
          v-on:input="setAssignments" />
      </b-row>
      <CRUDToolbar :clickFn="create"></CRUDToolbar>
    </b-form>
  </b-container>
</template>

<script>
import CRUDToolbar from '../components/CRUDToolbar'
import Countries from '../components/Selects/Countries'
import Assignment from '../components/Assignment'
import { toaster } from '../services/toast'
import FileInput from '../components/FileInput'
import jsonToFormData from 'json-form-data'
import { _underscore } from '@suben/keys_transformer'

export default {
  name: 'TheCertificationBodyCreate',
  components: {
    CRUDToolbar,
    Countries,
    FileInput,
    Assignment
  },
  data () {
    return {
      formInputs: {
        name: '',
        registration_number: '',
        country_id: '',
        userEmail: '',
        email: '',
        website: '',
        phone: '',
        moreContacts: '',
        street: '',
        zip: '',
        location: '',
        fax: '',
        intern_field: ''
      },
      assigned: false
    }
  },
  computed: {
    /**
     * @return {boolean}
     */
    showAssignmentError () {
      return this.isValid()
    }
  },
  methods: {
    isValid () {
      if (!('assignments' in this.formInputs)) {
        return false
      }

      const countAssignments = this.formInputs.assignments.filter(
        item => item.laboratory_id && item.product_type_id
      ).length

      return this.formInputs.assignments.length === countAssignments
    },
    /**
     *
     * @param value
     *
     * @return {void}
     */
    setAssignments (value) {
      this.$set(this.formInputs, 'assignments', value)
    },
    /**
     *
     * @param value
     * @param logoType
     *
     * @return {void}
     */
    setFile ({ value, logoType }) {
      if (logoType === 'logo' && ('logo_url' in this.formInputs)) {
        Reflect.deleteProperty(this.formInputs, 'logo_url')
      }

      if (logoType === 'logo_url' && ('logo' in this.formInputs)) {
        Reflect.deleteProperty(this.formInputs, 'logo')
      }

      this.formInputs[logoType] = value
    },
    /**
     *
     * @return {Promise<void>}
     */
    async create () {
      const initToaster = toaster(this.$bvToast)
      const validatedAll = await this.$validator.validateAll()

      if (!validatedAll || !this.isValid()) return

      try {
        const { data } = await this.$api.create('certificationBodies', jsonToFormData(
          Object.deleteEmpty(_underscore(this.formInputs, ['__ob__']))
        ))

        initToaster(200)(this.$t('notifications.success.title'), this.$t(`notifications.success.${200}`))

        this.$router.push(`/certificationBodies/${data.id}/detail`)
      } catch ({ data }) {
        const toaster = initToaster(data.status_code)

        toaster(this.$t('notifications.error.title'), this.$t(`notifications.error.${data.status_code}`))
      }
    },
    /**
     *
     * @param value
     *
     * @return {void}
     */
    setCountry (value) {
      this.formInputs.country_id = value
    }
  }
}
</script>
